import { useEffect } from 'react';

import { register } from '~/services/client';
import { useAuthStore } from '~/store/auth';

/**
 * AuthProvider is a non-rendering component that sets up the global
 * authentication logic for the application. It registers a callback
 * to handle API token refresh failures, ensuring the user is logged out
 * gracefully.
 */
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const logout = useAuthStore(state => state.logout);

  useEffect(() => {
    register(logout);
  }, [logout]);

  return <>{children}</>;
};
